// 📁 Imports
import { inputValidator } from "@/utils/input-validator.js";

// 💾 Variables

// 📐 Functions
const formValidator = (formIdentificator, showValidation = true) => {
  const formValidate = document.querySelector(
    `[data-form=${formIdentificator}]`,
  );
  
  if (!formValidate) {
    return { isValid: false, el: null };
  }
  
  const validateInputs = formValidate.querySelectorAll("[data-validate]");
  
  let formIsValid = true;
  const invalidInputs = [];

  Array.from(validateInputs).forEach((input) => {
    const inputTypeValid = input.dataset;

    // Always check validity for button state, but only show messages if showValidation is true
    const validationResult = inputValidator(input, inputTypeValid, showValidation);

    if (validationResult.errors.length > 0) {
      formIsValid = false;
      invalidInputs.push({
        input: input.name || input.id,
        errors: validationResult.errors
      });
    }
  });
  
  return { isValid: formIsValid, el: formValidate, invalidInputs };
};

// 🖱️ Event listener

// 📤 Export
export { formValidator };
